import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { handleApiError } from 'state/api';

export const signInApi = createAsyncThunk(
  'auth/signInApi',
  async ({ credentials, keepUserLoggedIn }, { rejectWithValue }) => {
    try {
      const response = await api.post('auth/login', credentials);
      return { data: response?.data, keepUserLoggedIn };
    } catch (error) {
      return handleApiError('signInApi', error, rejectWithValue);
    }
  },
);

export const createResetPasswordCodeApi = createAsyncThunk(
  'auth/createResetPasswordCodeApi',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await api.post('reset-password-code', { email });
      return response.data;
    } catch (error) {
      return handleApiError('createResetPasswordCodeApi', error, rejectWithValue);
    }
  },
);

export const verifyResetPasswordCodeApi = createAsyncThunk(
  'auth/verifyResetPasswordCodeApi',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.post('reset-password-code/verify', credentials);
      return response.data;
    } catch (error) {
      return handleApiError('verifyResetPasswordCodeApi', error, rejectWithValue);
    }
  },
);

export const resetPasswordApi = createAsyncThunk(
  'auth/resetPasswordApi',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.post('reset-password-code/reset-password', credentials);
      return response.data;
    } catch (error) {
      return handleApiError('resetPasswordApi', error, rejectWithValue);
    }
  },
);
